import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ChartsComponent } from './charts.component';
import { SurveyTitleModule, NavBarModule } from '../shared';
import { LoadingModule } from '@schoolbelle/common/loading';

import { 
  QuestionRadioModule,
  QuestionCheckboxModule,
  QuestionTextModule,
  QuestionTableCheckboxModule,
  QuestionAfterschoolModule,
} from './components/questions';
import { PhoneNumberPipe } from '@schoolbelle/common/phone-number';
import { ChartsService } from './charts.service';

@NgModule({
  imports: [
    CommonModule,
    // NavBarModule,
    LoadingModule.forRoot(),
    SurveyTitleModule,     
    
    QuestionRadioModule,
    QuestionCheckboxModule,
    QuestionTextModule,
    QuestionTableCheckboxModule,
    QuestionAfterschoolModule,
  ],
  providers:[DatePipe, PhoneNumberPipe, ChartsService],
  exports:[
    CommonModule,
    // NavBarModule,
    LoadingModule,
    SurveyTitleModule,     
 
    QuestionRadioModule,
    QuestionCheckboxModule,
    QuestionTextModule,
    QuestionTableCheckboxModule,
    QuestionAfterschoolModule,
  ],
  declarations: [ChartsComponent]
})
export class ChartsModule { }
